import { MessageTypes } from './Message';

const paddingRight = 4.5625;

export const container = ({ type, theme }) => ({
    border: `1px solid ${type === MessageTypes.ERROR ? theme.colors.red : theme.colors.cyan}`,

    display: 'flex',
    alignItems: 'flex-start',

    paddingLeft: '1.0625rem',
    paddingRight: '1.1875rem',
    paddingTop: '1.1875rem',
    paddingBottom: '1.1875rem',

    willChange: 'opacity',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) opacity 0.3s',

    tablet: {
        maxWidth: `${30.875 - paddingRight}rem`,

        paddingLeft: '1.0625rem',
        paddingRight: `${paddingRight}rem`,
        paddingTop: '1.1875rem',
        paddingBottom: '1.1875rem',
    },
});

export const text = () => ({
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    width: '80%',
    maxWidth: '23.1875rem',

    tablet: {
        width: 'auto',
    },
});

export const icon = ({ theme: { colors }, type }) => ({
    fill: type === MessageTypes.ERROR ? colors.red : colors.cyan,
    width: type === MessageTypes.ERROR ? '1.4375rem' : '2.125rem',
    marginTop: '0.25rem',
    marginRight: '1.4375rem',
});
